import React, { useEffect, useState } from "react"
import { BidModel } from "../../../models/bid/BidModel"
import "./ChangeMarket.scss"
import { t } from "i18next"
type Props = {
    bids: BidModel[]
    onSelectedBid: any
    style?: React.CSSProperties
}

export function ChangeMarket({ bids, onSelectedBid, style }: Props) {

    const [selectedBid, setSelectedBid] = useState(bids?.at(0))

    function isSelected(b: BidModel) {
        return b.market_day === selectedBid?.market_day
    }

    useEffect(() => {
        onSelectedBid(selectedBid)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBid])

    if (!bids?.length) {
        return null
    }

    return <div className="pem-tabs" style={{ ...style }} >
        {
            bids.map((b, index) => {
                return <button 
                    key={`${b.id}/${b.market_day}/${index}`}
                    className={`pem-tab ${isSelected(b) ? 'pem-tab--active' : ''}`}
                    onClick={() => setSelectedBid(b)}>
                    {index === 0 ? t('today') : index === 1 ? t('tomorrow') : ""} ({b.market_day})
                </button>
            })
        }
    </div>
}